import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useWorkBlockEditModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.editWorkBlockModalState, ...args };
    updateGlobalState({ editWorkBlockModalState: newState });
  };

  return {
    block: state.editWorkBlockModalState.block,
    close: () => {
      setState({ block: null, isOpen: false });
    },
    isOpen: state.editWorkBlockModalState.isOpen,
    open: (block) => {
      setState({ block, isOpen: true });
    },
  };
}
